var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center"},[_vm._v("Oops... "+_vm._s(_vm.message)+"!"),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"/"}},[_vm._v("Go back home")])])}
var staticRenderFns = []

export { render, staticRenderFns }